import type { BaseUser } from "#shared/types";
import { UserRole } from "#shared/enums";

export default function useGetUserRole(user: BaseUser | null | undefined) {
  const hasRole = (role: UserRole) =>
    user?.roles?.some((r) => r.name === role) ?? false;

  const isSuperAdmin = () => hasRole(UserRole.SUPER_ADMIN);
  const isAdmin = () => hasRole(UserRole.ADMIN);
  const isAnyAdmin = () => isSuperAdmin() || isAdmin();

  const isContentCreator = () => hasRole(UserRole.CONTENT_CREATOR);
  const isSubCreator = () => hasRole(UserRole.SUB_CONTENT_CREATOR);
  const isAnyCreator = () => isContentCreator() || isSubCreator();

  const isViewer = () => hasRole(UserRole.VIEWER);

  return {
    hasRole,
    isSuperAdmin,
    isAdmin,
    isContentCreator,
    isSubCreator,
    isAnyAdmin,
    isAnyCreator,
    isViewer,
  };
}
